if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.closest('.popup-wrapper__quick-view') && !document.body.classList.contains('hidden')) document.body.classList.add('hidden');

      this.form = this.querySelector('form');
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';

      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    
      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
    
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const drawerSections = cartDrawer?.getSectionsToRender?.() || [];
      const notificationSections = cartNotification?.getSectionsToRender?.() || [];
      const allSections = [...drawerSections, ...notificationSections];
      const uniqueSectionIds = [...new Set(allSections.map((s) => s.id))];
      formData.append('sections', uniqueSectionIds.join(','));
    
      const config = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      };
    
      try {
        const res = await fetch(`${routes.cart_add_url}`, config);
        const contentType = res.headers.get('content-type');
        let data;
    
        if (contentType && contentType.includes('application/json')) {
          data = await res.json();
        } else {
          const fallbackHtml = await res.text();
          const fallbackRes = await fetch(
            `/?sections=${uniqueSectionIds.join(',')}&sections_url=${window.location.pathname}`
          );
          const fallbackSections = await fallbackRes.json();
          data = {
            sections: fallbackSections,
            fallback: true
          };
        }
    
        const isPartialAdd = data?.description?.includes('available');
        const isError = data.status && !isPartialAdd;
    
        if (isError) {
          this.handleErrorMessage(data.message || data.description);
          this.showSoldOutState();
          return;
        }
    
        const shouldOpenDrawer = cartDrawer?.classList.contains('open-after-adding');
        const shouldOpenNotification = !shouldOpenDrawer && cartNotification;

            localStorage.setItem('openCartAfterReload', 'true');

        if (cartDrawer?.renderContents) {
  cartDrawer.renderContents(data);
  cartDrawer.open(); // Explicitly open after adding
}

    
        if (shouldOpenNotification && cartNotification?.renderContents) {
          const addedVariantId = this.form.querySelector('[name="id"]')?.value;
          try {
            const cartJson = await fetch('/cart.js').then(res => res.json());
            const items = cartJson.items || [];
            let addedItemKey = null;

            for (const item of items) {
              if (item.variant_id?.toString() === addedVariantId?.toString()) {
                addedItemKey = item.key;
                break;
              }
            }
            cartNotification.renderContents({
              ...data,
              key: addedItemKey
            });
          } catch (err) {
            cartNotification.renderContents(data); // fallback
          }
        }
    
        if (isPartialAdd) {
          this.handleErrorMessage(data.description);
        }
    
      } catch (error) {
        console.error('Cart add error:', error);
        this.handleErrorMessage('An error occurred while adding to the cart.');
      } finally {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }

    showSoldOutState() {
      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      if (soldOutMessage) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span')?.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}